import logoLight from "~/src/assets/logo-light.png";

export const EDITOR_PASTE_MAX_NUM_CHARACTERS = 60000;

export const EDITOR_PASTE_TAG_BLACKLIST =
  "animate|animation|applet|area|audio|base|bgsound|body|" +
  "comment|details|doc|embed|eval|event-source|form|frameset|handler|head|html|iframe|image|" +
  "import|input|link|listener|map|marquee|math|meta|object|param|picture|schema|script|set|style|" +
  "svg|template|title|video|vmlframe|x|xml|xmp|xsl";

export const EDITOR_DOMPURIFY_CONFIG = {
  USE_PROFILES: {html: true},
  FORBID_TAGS: EDITOR_PASTE_TAG_BLACKLIST.split("|"),
  FORBID_ATTR: ["draggable", "pattern", "srcset", "xmlns"],
};

export const editorPrintTemplate = () => {
  return `<img src="${logoLight}" style="height: 60px">
    {{contents}}
  <h5>&#169;${new Date().getFullYear()} Confidential & Proprietary Information</h5>`;
};

export const editorFonts = [
  "Arial",
  "Courier New",
  "Georgia",
  "Helvetica Neue",
  "Impact",
  "Lato",
  "Oswald",
  "Roboto",
  "Tahoma",
  "Verdana",
  "Geist",
  "Saira Semi Condensed",
];

export const editorButtons = ({theme, noPrint}) => {
  const miscButtons = ["-right", ":i-Misc-default.more_vertical", "fullScreen", "showBlocks"];

  const printButtons = noPrint ? [] : ["-right", "print"];

  return [
    ["undo", "redo"],
    ["font", "fontSize"],
    [
      ":p-More Paragraph-default.more_paragraph",
      "lineHeight",
      "formatBlock",
      "paragraphStyle",
      "blockquote",
      "removeFormat",
    ],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["fontColor", "hiliteColor", "textStyle"],
    ["outdent", "indent"],
    ["align", "horizontalRule", "list"],
    [":r-More Rich-default.more_plus", "table", "link"],
    printButtons,
    miscButtons,
    [
      `%${theme.breakpoints.values["md"]}`,
      [
        ["undo", "redo"],
        [
          ":p-More Paragraph-default.more_paragraph",
          "font",
          "fontSize",
          "formatBlock",
          "paragraphStyle",
          "blockquote",
        ],
        ["bold", "underline", "italic", "strike"],
        [
          ":t-More Text-default.more_text",
          "subscript",
          "superscript",
          "fontColor",
          "hiliteColor",
          "textStyle",
          "removeFormat",
          "lineHeight",
        ],
        ["outdent", "indent"],
        ["align", "horizontalRule", "list"],
        printButtons,
        miscButtons,
        ["-right", ":r-More Rich-default.more_plus", "table", "link"],
      ],
    ],
    [
      `%${theme.breakpoints.values["sm"]}`,
      [
        ["undo", "redo"],
        [
          ":p-More Paragraph-default.more_paragraph",
          "font",
          "fontSize",
          "formatBlock",
          "paragraphStyle",
          "blockquote",
        ],
        [
          ":t-More Text-default.more_text",
          "bold",
          "underline",
          "italic",
          "strike",
          "subscript",
          "superscript",
          "fontColor",
          "hiliteColor",
          "textStyle",
          "removeFormat",
        ],
        [
          ":e-More Line-default.more_horizontal",
          "outdent",
          "indent",
          "align",
          "horizontalRule",
          "list",
          "lineHeight",
        ],
        printButtons,
        [":r-More Rich-default.more_plus", "table", "link"],
        miscButtons,
      ],
    ],
  ];
};
